import { request } from './index';
import { Loadable } from 'recoil';
import { ColorNumber } from '../types/colors';
// import { RecoilLoadable} from 'recoil';
// import { questions } from '../json/questions';

export interface GetQuestionsParam {
  token: string;
}
export interface Questions {
  result: 'OK' | 'NG';
  message: string | null;
  color: ColorNumber;
  icon: string;
  questions: Question[];
}
export interface Question {
  questionId: number;
  dispName: string;
  forFirstVisit: boolean;
  forRevisit: boolean;
  boundaryAge: number;
  inequalitySign: number
}

export const getQuestions = (param: GetQuestionsParam): Loadable<Questions> => {
  return request('GetQuestions', param);
  // return RecoilLoadable.of(new Promise((resolve => { setTimeout(() => resolve(questions), 200) })));
}
